/* =============================================================
   ISD product page script (blocks/isd-product.liquid)
   - gallery thumbnails
   - real Shopify variant selection (never adds a wrong variant)
   - AJAX add to cart through window.ISD.cart with error recovery
   - sticky mobile buy bar
   - upsell: Shopify product recommendations or a collection
   - box add-ons: the special-price catalogue is always visible on a box page;
     cards are locked until ISD.state (the real cart) reports a qualifying box
   - add-on product page: the purchase form is gated the same way
   ============================================================= */
(function () {
  'use strict';

  var TEXT = Object.assign({ adding: 'Pridedama…', added: 'Pridėta', error: 'Nepavyko pridėti. Bandykite dar kartą.', more: 'Rodyti daugiau', loading: 'Kraunama…', empty: 'Šioje kategorijoje produktų nėra.', add: 'Pridėti', soldout: 'Išparduota', from: 'Nuo ', locked: 'Prieinama su dėžute', withBox: 'Kaina su dėžute', chooseVariant: 'Pasirinkite variantą.', unavailable: 'Šis derinys negalimas', loadFail: 'Nepavyko įkelti produktų. Atnaujinkite puslapį.' }, (window.ISD && window.ISD.ui) || {});

  function money(cents) { return window.ISD ? window.ISD.money(cents) : (cents / 100).toFixed(2); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
  function handleize(s) { return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function imgUrl(src, width) { if (!src) return ''; return src.replace(/(\.[a-z]{3,4})(\?.*)?$/i, '_' + width + 'x$1$2'); }

  var CART_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h12l1 13H5L6 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>';
  var LOCK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';

  /* ---------- Card renderer (same markup as snippets/isd-product-card.liquid) ---------- */
  function cardHtml(p, opts) {
    opts = opts || {};
    var variants = (p.variants || []).filter(function (v) { return v.available !== false; });
    var all = p.variants || [];
    var first = variants[0] || all[0];
    var price = p.price_min != null ? Number(p.price_min) : (first ? Number(first.price) : 0);
    var compare = (!opts.noCompare && first && first.compare_at_price) ? Number(first.compare_at_price) : 0;
    var image = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    var url = p.url || ('/products/' + p.handle);
    var available = p.available !== false && variants.length > 0;
    var badges = '';
    if (compare > price) badges += '<span class="isd-badge isd-badge--sale">-' + Math.round((compare - price) / compare * 100) + '%</span>';
    if (!available) badges += '<span class="isd-badge isd-badge--soldout">' + TEXT.soldout + '</span>';
    var selectId = 'isd-sel-' + p.id + '-' + Math.random().toString(36).slice(2, 7);
    var openAttr = ' data-isd-open="' + (opts.openCart ? 'true' : 'false') + '"';
    var addLabel = opts.addLabel || TEXT.add;
    var action, variantSelect = '';
    if (!available) {
      action = '<button type="button" class="isd-card__add" disabled><span class="isd-card__add-label">' + TEXT.soldout + '</span></button>';
    } else if (opts.locked) {
      action = '<span class="isd-card__add isd-card__add--locked" aria-hidden="true">' + LOCK_ICON + '<span class="isd-card__add-label">' + esc(opts.lockedLabel || TEXT.locked) + '</span></span>';
    } else if (all.length === 1) {
      action = '<button type="button" class="isd-card__add" data-isd-add="' + first.id + '" data-label-default="' + esc(addLabel) + '"' + openAttr + ' aria-label="' + esc(addLabel) + ': ' + esc(p.title) + '">' + CART_ICON + '<span class="isd-card__add-label">' + esc(addLabel) + '</span></button>';
    } else {
      variantSelect = '<div class="isd-upsell__variant"><select id="' + selectId + '" aria-label="Pasirinkite variantą">' + all.map(function (v) { return '<option value="' + v.id + '"' + (v.available === false ? ' disabled' : '') + '>' + esc(v.title) + (v.available === false ? ' — ' + TEXT.soldout.toLowerCase() : '') + '</option>'; }).join('') + '</select></div>';
      action = '<button type="button" class="isd-card__add" data-isd-add="' + first.id + '" data-isd-select="' + selectId + '" data-label-default="' + esc(addLabel) + '"' + openAttr + ' aria-label="' + esc(addLabel) + ': ' + esc(p.title) + '">' + CART_ICON + '<span class="isd-card__add-label">' + esc(addLabel) + '</span></button>';
    }
    var type = opts.showType !== false && p.type ? '<span class="isd-card__type">' + esc(p.type) + '</span>' : '';
    var tag = opts.priceTag ? '<span class="isd-card__tag">' + esc(opts.priceTag) + '</span>' : '';
    var sr = opts.locked && available ? '<span class="isd-visually-hidden"> — ' + esc(opts.lockedLabel || TEXT.locked) + '</span>' : '';
    return '<article class="isd-card' + (opts.locked ? ' isd-card--locked' : '') + '" data-isd-card data-product-id="' + p.id + '">'
      + '<div class="isd-card__media">' + (image ? '<img class="isd-card__img isd-card__img--first" src="' + esc(imgUrl(image, 480)) + '" alt="' + esc(p.title) + '" width="480" height="480" loading="lazy">' : '') + (badges ? '<div class="isd-card__badges">' + badges + '</div>' : '') + action + '</div>'
      + '<div class="isd-card__body">' + type + '<a class="isd-card__title" href="' + esc(url) + '">' + esc(p.title) + sr + '</a><div class="isd-card__price' + (compare > price ? ' isd-card__price--sale' : '') + '"><span class="isd-card__price-now">' + (p.price_varies ? TEXT.from : '') + money(price) + '</span>' + (compare > price ? '<s>' + money(compare) + '</s>' : '') + tag + '</div>' + variantSelect + '</div>'
      + '<a class="isd-card__link" href="' + esc(url) + '" tabindex="-1" aria-hidden="true"></a>'
      + '</article>';
  }

  /* products.json gives decimal strings; recommendations give cents. Normalise to cents. */
  function normalizeProduct(p, source) {
    var cents = function (v) { if (v == null) return 0; if (source === 'json') return Math.round(parseFloat(v) * 100); return Number(v); };
    return {
      id: p.id, title: p.title, handle: p.handle, url: p.url || ('/products/' + p.handle),
      tags: Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map(function (t) { return t.trim(); }),
      type: p.product_type || p.type || '',
      available: p.available !== undefined ? p.available : (p.variants || []).some(function (v) { return v.available; }),
      featured_image: p.featured_image || (p.images && p.images[0] ? (p.images[0].src || p.images[0]) : ''),
      price_min: p.price_min != null ? cents(p.price_min) : cents((p.variants || [{}])[0].price),
      price_varies: !!p.price_varies,
      variants: (p.variants || []).map(function (v) { return { id: v.id, title: v.title, available: v.available !== false, price: cents(v.price), compare_at_price: v.compare_at_price ? cents(v.compare_at_price) : 0 }; })
    };
  }

  /* ---------- Delivery estimate: business days only (Mon–Fri), optional cutoff hour ---------- */
  var MONTHS_LT = ['sausio', 'vasario', 'kovo', 'balandžio', 'gegužės', 'birželio', 'liepos', 'rugpjūčio', 'rugsėjo', 'spalio', 'lapkričio', 'gruodžio'];
  function addBusinessDays(date, n) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function nextBusinessStart(now, cutoff) {
    var d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var w = d.getDay();
    var late = cutoff > 0 && now.getHours() >= cutoff;
    if (w === 0 || w === 6 || late) d = addBusinessDays(d, 1);
    return d;
  }
  function fmtLt(d) { return MONTHS_LT[d.getMonth()] + ' ' + d.getDate() + ' d.'; }
  function fmtRange(a, b) {
    if (a.getTime() === b.getTime()) return fmtLt(a);
    if (a.getMonth() === b.getMonth()) return MONTHS_LT[a.getMonth()] + ' ' + a.getDate() + '–' + b.getDate() + ' d.';
    return fmtLt(a) + ' – ' + fmtLt(b);
  }
  function initDelivery(el) {
    var now = new Date();
    var start = nextBusinessStart(now, Number(el.getAttribute('data-cutoff') || 0));
    var ship = addBusinessDays(start, Number(el.getAttribute('data-processing') || 0));
    var from = addBusinessDays(ship, Number(el.getAttribute('data-ship-min') || 1));
    var to = addBusinessDays(ship, Math.max(Number(el.getAttribute('data-ship-min') || 1), Number(el.getAttribute('data-ship-max') || 1)));
    var shipEl = el.querySelector('[data-isd-delivery-ship]');
    var arriveEl = el.querySelector('[data-isd-delivery-arrive]');
    var shipText = (el.getAttribute('data-ship-text') || '').replace('{ship}', fmtLt(ship));
    var arriveText = (el.getAttribute('data-arrive-text') || '').replace('{range}', fmtRange(from, to)).replace('{from}', fmtLt(from)).replace('{to}', fmtLt(to));
    if (shipEl) shipEl.textContent = shipText;
    if (arriveEl) { arriveEl.textContent = arriveText; arriveEl.hidden = !arriveText; }
    el.hidden = !shipText && !arriveText;
  }

  /* ---------- Box eligibility from the shared cart state ---------- */
  function onBoxState(fn) {
    if (window.ISD && window.ISD.state) { window.ISD.state.subscribe(function (st) { fn(!!st.hasBox, st); }); return; }
    document.addEventListener('isd:state', function (e) { fn(!!e.detail.state.hasBox, e.detail.state); });
  }

  /* ---------- Per-page init ---------- */
  function initProduct(root) {
    if (root.dataset.isdReady === '1') return;
    root.dataset.isdReady = '1';

    var jsonEl = root.querySelector('[data-isd-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var buy = root.querySelector('[data-isd-buy]');
    var form = root.querySelector('[data-isd-form]');
    var variantInput = root.querySelector('[data-isd-variant-id]');
    var qtyInput = root.querySelector('[data-isd-qty-input]');
    var atc = root.querySelector('[data-isd-atc]');
    var atcLabel = root.querySelector('[data-isd-atc-label]');
    var errorEl = root.querySelector('[data-isd-error]');
    var priceNow = root.querySelector('[data-isd-price-now]');
    var priceCompare = root.querySelector('[data-isd-price-compare]');
    var priceBadge = root.querySelector('[data-isd-price-badge]');
    var stock = root.querySelector('[data-isd-stock]');
    var sticky = root.querySelector('[data-isd-sticky]');
    var delivery = root.querySelector('[data-isd-delivery]');
    var gate = root.querySelector('[data-isd-gate]');
    if (delivery) initDelivery(delivery);

    /* Gallery */
    var gallery = root.querySelector('[data-isd-gallery]');
    function showSlide(i) {
      if (!gallery) return;
      gallery.querySelectorAll('[data-isd-slide]').forEach(function (s) { s.setAttribute('data-active', s.getAttribute('data-isd-slide') === String(i) ? 'true' : 'false'); });
      gallery.querySelectorAll('[data-isd-thumb]').forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-isd-thumb') === String(i) ? 'true' : 'false'); });
    }
    if (gallery) gallery.addEventListener('click', function (e) { var t = e.target.closest('[data-isd-thumb]'); if (t) showSlide(t.getAttribute('data-isd-thumb')); });
    function showMedia(mediaId) {
      if (!gallery || !mediaId) return;
      var s = gallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (s) showSlide(s.getAttribute('data-isd-slide'));
    }

    /* Variants */
    var selected = [];
    root.querySelectorAll('[data-isd-option-value]').forEach(function (el) { selected[Number(el.getAttribute('data-isd-option-value'))] = el.textContent; });
    function findVariant() {
      if (!product) return null;
      if (!selected.length) return product.variants[0];
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return selected[i] === undefined || o === selected[i]; }); }) || null;
    }
    function applyVariant(v) {
      var available = !!(v && v.available);
      if (variantInput) variantInput.value = v ? v.id : '';
      if (priceNow && v) priceNow.textContent = money(v.price);
      if (priceCompare) {
        var onSale = v && v.compare_at_price > v.price && !root.classList.contains('isd-pp--addon');
        priceCompare.hidden = !onSale;
        if (onSale) priceCompare.textContent = money(v.compare_at_price);
        if (priceBadge) { priceBadge.hidden = !onSale; if (onSale) priceBadge.textContent = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '% ' + (priceBadge.getAttribute('data-label') || ''); }
      }
      if (stock) { stock.classList.toggle('is-out', !available); stock.textContent = available ? stock.getAttribute('data-in') : (v ? stock.getAttribute('data-out') : TEXT.unavailable); }
      if (atc) { atc.disabled = !available; if (atcLabel) atcLabel.textContent = available ? atc.getAttribute('data-label-default') : atc.getAttribute('data-label-soldout'); }
      if (v && v.featured_media) showMedia(v.featured_media.id);
      if (sticky && v) { var sp = sticky.querySelector('[data-isd-sticky-price]'); if (sp) sp.textContent = money(v.price); var sb = sticky.querySelector('[data-isd-sticky-atc]'); if (sb) sb.disabled = !available; }
      if (v && window.history && window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState(null, '', u.toString()); }
      root.querySelectorAll('[data-isd-option]').forEach(function (pill) {
        var idx = Number(pill.getAttribute('data-isd-option'));
        var test = selected.slice(); test[idx] = pill.getAttribute('data-value');
        var exists = product.variants.some(function (pv) { return pv.available && pv.options.every(function (o, i) { return i > idx ? true : o === test[i]; }); });
        pill.classList.toggle('is-unavailable', !exists);
      });
    }
    root.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-isd-option]');
      if (!pill) return;
      var idx = Number(pill.getAttribute('data-isd-option'));
      selected[idx] = pill.getAttribute('data-value');
      root.querySelectorAll('[data-isd-option="' + idx + '"]').forEach(function (p) { p.setAttribute('aria-checked', p === pill ? 'true' : 'false'); });
      var label = root.querySelector('[data-isd-option-value="' + idx + '"]'); if (label) label.textContent = selected[idx];
      applyVariant(findVariant());
    });

    /* Quantity */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-isd-qty]');
      if (!b || !qtyInput) return;
      var next = Math.max(1, Math.min(99, (parseInt(qtyInput.value, 10) || 1) + Number(b.getAttribute('data-isd-qty'))));
      qtyInput.value = next;
    });

    /* Add-on product page: purchase form only with a box in the real cart */
    var unlocked = !gate;
    if (gate) {
      var lockedEl = gate.querySelector('[data-isd-gate-locked]');
      var openEl = gate.querySelector('[data-isd-gate-open]');
      var stickyLink = sticky ? sticky.querySelector('[data-isd-sticky-boxes]') : null;
      var stickyBtnEl = sticky ? sticky.querySelector('[data-isd-sticky-atc]') : null;
      onBoxState(function (hasBox) {
        unlocked = hasBox;
        gate.setAttribute('data-state', hasBox ? 'open' : 'locked');
        if (lockedEl) lockedEl.hidden = hasBox;
        if (openEl) openEl.hidden = !hasBox;
        if (stickyLink) stickyLink.hidden = hasBox;
        if (stickyBtnEl) stickyBtnEl.hidden = !hasBox;
      });
    }

    /* Add to cart */
    function showError(msg) { if (!errorEl) return; errorEl.textContent = msg; errorEl.hidden = false; }
    function submit() {
      if (!atc || atc.disabled || atc.classList.contains('is-loading') || !window.ISD) return;
      if (!unlocked) { showError(window.ISD.state ? window.ISD.state.text.addonBlocked : TEXT.locked); return; }
      var id = variantInput ? variantInput.value : null;
      if (!id) { showError(TEXT.chooseVariant); return; }
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var original = atc.getAttribute('data-label-default');
      if (errorEl) errorEl.hidden = true;
      atc.classList.add('is-loading'); atc.setAttribute('aria-busy', 'true'); if (atcLabel) atcLabel.textContent = TEXT.adding;
      window.ISD.cart.add(id, qty).then(function () {
        atc.classList.remove('is-loading'); atc.classList.add('is-added'); if (atcLabel) atcLabel.textContent = TEXT.added;
        if (root.getAttribute('data-open-cart') !== 'false') window.ISD.cart.open();
        setTimeout(function () { atc.classList.remove('is-added'); if (atcLabel) atcLabel.textContent = original; }, 1600);
      }).catch(function (err) {
        atc.classList.remove('is-loading'); atc.classList.add('is-error'); if (atcLabel) atcLabel.textContent = original;
        showError(err && err.status === 422 && err.message ? err.message : TEXT.error);
        setTimeout(function () { atc.classList.remove('is-error'); }, 1800);
      }).finally(function () { atc.removeAttribute('aria-busy'); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    if (sticky) {
      var stickyBtn = sticky.querySelector('[data-isd-sticky-atc]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () { if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' }); submit(); });
      var watch = atc || gate;
      if (watch && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }, { threshold: 0 }).observe(watch);
    }

    /* Upsell for normal products */
    var upsell = root.querySelector('[data-isd-upsell]');
    if (upsell && upsell.getAttribute('data-source') === 'recommendations') {
      var grid = upsell.querySelector('[data-isd-upsell-grid]');
      var limit = Number(upsell.getAttribute('data-limit') || 4);
      fetch('/recommendations/products.json?product_id=' + upsell.getAttribute('data-product-id') + '&limit=' + limit + '&intent=related', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.products || []).map(function (p) { return normalizeProduct(p, 'cents'); });
          if (!items.length) { upsell.hidden = true; return; }
          grid.innerHTML = items.map(function (p) { return cardHtml(p, { openCart: true, showType: false }); }).join('');
          upsell.hidden = false;
        }).catch(function () { upsell.hidden = true; });
    }

    /* Box add-ons / collection upsell with category pills */
    root.querySelectorAll('[data-isd-box-addons]').forEach(function (el) { initBoxAddons(el, product); });
  }

  function initBoxAddons(box, product) {
    var pillsEl = box.querySelector('[data-isd-addon-pills]');
    var grid = box.querySelector('[data-isd-addon-grid]');
    var state = box.querySelector('[data-isd-addon-state]');
    var moreWrap = box.querySelector('[data-isd-addon-more]');
    var moreBtn = moreWrap ? moreWrap.querySelector('button') : null;
    var textEl = box.querySelector('[data-isd-box-text]');
    var markEl = box.querySelector('[data-isd-box-mark]');
    var handle = box.getAttribute('data-collection');
    var boxId = Number(box.getAttribute('data-box-product-id'));
    var categories = (box.getAttribute('data-categories') || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean).map(function (c) { var parts = c.split('|').map(function (x) { return x.trim(); }).filter(Boolean); return { label: parts[0], terms: parts }; });
    var pageSize = Number(box.getAttribute('data-page-size') || 8);
    var allLabel = box.getAttribute('data-all-label') || 'Visi';
    var gated = !box.hasAttribute('data-isd-ungated');
    var restrict = box.hasAttribute('data-isd-restrict');
    var lockedLabel = box.getAttribute('data-locked-label') || TEXT.locked;
    var addLabel = box.getAttribute('data-add-label') || TEXT.add;
    var priceTag = box.getAttribute('data-price-tag') || '';
    var products = null, loaded = false, loading = false, active = '', shown = pageSize, locked = gated;

    var ALIAS = { 'olive oil': 'aliejus', oil: 'aliejus', pasta: 'makaronai', coffee: 'kava', sauces: 'padazai', sauce: 'padazai', olives: 'alyvuoges', yeast: 'mieles', balsamic: 'balzaminiai', 'balsamic vinegar': 'balzaminis-actas', delicacies: 'delikatesai', crackers: 'krekeriai', jams: 'dzemai', jam: 'dzemai', snacks: 'uzkandziai', sweets: 'saldumynai', biscuits: 'sausainiai', tomatoes: 'pomidorai', 'tomato puree': 'pomidoru-tyre', 'canned tomatoes': 'konservuoti-pomidorai', 'sun-dried tomatoes': 'dziovinti-pomidorai', flour: 'miltai', 'truffle paste': 'triufeliu-pasta', pate: 'pastetas', spreads: 'uztepeles' };
    function matches(p, cat) {
      if (!cat) return true;
      var terms = (typeof cat === 'string' ? [cat] : cat.terms);
      var type = norm(p.type);
      var tags = p.tags.map(norm);
      return terms.some(function (term) {
        var n = norm(term), h = handleize(term), a = ALIAS[n];
        return type === n || tags.indexOf(n) > -1 || tags.indexOf('box-addon-category:' + h) > -1 || tags.indexOf('kategorija:' + h) > -1 || (a && (type === a || tags.indexOf('box-addon-category:' + a) > -1 || tags.indexOf('kategorija:' + a) > -1 || tags.indexOf(a) > -1));
      });
    }
    function findCategory(label) { return categories.filter(function (c) { return norm(c.label) === norm(label); })[0] || null; }
    function inAnyCategory(p) { return !restrict || categories.some(function (c) { return matches(p, c); }); }
    function visibleProducts() { var cat = active ? findCategory(active) : null; return products.filter(function (p) { return p.id !== boxId && inAnyCategory(p) && matches(p, cat); }); }
    function render() {
      if (!products) return;
      var list = visibleProducts();
      grid.innerHTML = list.slice(0, shown).map(function (p) { return cardHtml(p, { openCart: !gated, showType: false, locked: locked, lockedLabel: lockedLabel, addLabel: addLabel, priceTag: priceTag, noCompare: !!priceTag || gated }); }).join('');
      state.hidden = list.length > 0; state.textContent = TEXT.empty;
      if (moreWrap) { moreWrap.hidden = list.length <= shown; if (moreBtn) moreBtn.textContent = TEXT.more + ' (' + (list.length - shown) + ')'; }
    }
    function renderPills() {
      if (!pillsEl || !products) return;
      var html = '<button type="button" class="isd-pill" data-isd-cat="" aria-pressed="' + (active === '' ? 'true' : 'false') + '">' + esc(allLabel) + '</button>';
      categories.forEach(function (c) {
        if (!products.some(function (p) { return p.id !== boxId && matches(p, c); })) return;
        html += '<button type="button" class="isd-pill" data-isd-cat="' + esc(c.label) + '" aria-pressed="' + (norm(active) === norm(c.label) ? 'true' : 'false') + '">' + esc(c.label) + '</button>';
      });
      pillsEl.innerHTML = html;
    }
    function load() {
      if (loaded || loading || !handle) { if (!handle) { state.hidden = false; state.textContent = TEXT.empty; } return; }
      loading = true;
      state.hidden = false; state.textContent = TEXT.loading;
      fetch('/collections/' + handle + '/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          products = (d.products || []).map(function (p) { return normalizeProduct(p, 'json'); });
          loaded = true; loading = false;
          renderPills(); render();
        })
        .catch(function () { loading = false; state.hidden = false; state.textContent = TEXT.loadFail; });
    }
    box.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-isd-cat]');
      if (pill) { active = pill.getAttribute('data-isd-cat'); shown = pageSize; renderPills(); render(); if (pill.scrollIntoView) pill.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); return; }
      if (moreBtn && e.target === moreBtn) { shown += pageSize; render(); }
    });

    /* Locked ↔ unlocked. Only the real cart (ISD.state) decides. */
    function setLocked(v) {
      if (v === locked && box.dataset.isdInit === '1') return;
      locked = v; box.dataset.isdInit = '1';
      box.setAttribute('data-state', v ? 'locked' : 'open');
      if (textEl) textEl.textContent = textEl.getAttribute(v ? 'data-locked' : 'data-unlocked') || '';
      if (markEl) markEl.innerHTML = v ? LOCK_ICON : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
      render();
    }
    load();
    if (gated) { box.setAttribute('data-state', 'locked'); onBoxState(function (hasBox) { setLocked(!hasBox); }); }
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-isd-product]').forEach(initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) { boot(e.target); });
})();

/* Rating summary → reviews section (smooth scroll with the same Lenis-safe fallback as the hero CTAs) */
(function () {
  if (window.__isdReviewsLinkBound) return;
  window.__isdReviewsLinkBound = true;
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-isd-reviews-link]');
    if (!a) return;
    var id = (a.getAttribute('href') || '').replace('#', '');
    var t = id && document.getElementById(id);
    if (!t) return;
    e.preventDefault();
    var off = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--site-header-height')) || 0;
    var top = Math.max(0, t.getBoundingClientRect().top + window.pageYOffset - off - 8);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo(0, top); return; }
    var start = window.pageYOffset;
    window.scrollTo({ top: top, behavior: 'smooth' });
    setTimeout(function () { if (Math.abs(window.pageYOffset - start) < 4) window.scrollTo(0, top); }, 260);
  });
})();
